import React, { useState, useEffect } from "react";
import ContributionFilter from "./ContributionsFilter";
import { Pagination, Row, Col, Button } from "antd";
import { ContributionsReportPager, ContributionsDetails } from "../../services/apiService";
import DetailReportContent from "./DetailReportContent"
import { showApiError } from "../utilities";
import { CSVLink } from 'react-csv'
import "moment/locale/en-nz";
import moment from "moment";
import CreateAndSavePDF from './GenContDetailsPDF'

function DetailReportContainer(props) {
  const [data, setData] = useState([]);
  const [detailData, setDetail] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [readyPDF, setReadyPDF] = useState(false)
  const [currentPage, setCurrentPage] = useState(0) ;
  const [search, setSearch] = useState({ fromDate: moment().day(0), toDate: moment(),contId:0})
 // let today = moment();
//  let fromDate = moment().day(0);

  useEffect(() => {
    if (search.fromDate !== "" && currentPage > 0) {
      let contId = data[currentPage - 1].contributorId
      let querystring = `?from=${search.fromDate.format('YYYYMMDD')}&to=${search.toDate.format('YYYYMMDD')}&contId=${contId}`;
      //console.log(`useEffectr ${querystring}`)
      LoadDetailData(querystring)
    }

  }, [currentPage])

  function handleSearch(query) {
    let querystring = `?from=${query.fromDate}&to=${query.toDate}&contId=${
      query.contId
    }`;
    setCurrentPage(0)
    setSearch({ ...query, fromDate: moment(query.fromDate), toDate: moment(query.toDate) })
    //console.log(`${querystring}`);
    LoadData(querystring);
    LoadReportData(querystring);
  }

  function LoadData(querystring) {
    ContributionsReportPager(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json

          setData(json);
          if (json.length > 0) {
            setCurrentPage(1)
          }
        }
      })
      .catch(error => {
        showApiError(error);
      });
  }


  function FinishDownloadPDF() {
    setReadyPDF(false)
  }

  function LoadReportData(querystring) {
    ContributionsDetails(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json
          setReportData(json);
          //console.log(`LoadReportData ${querystring}`)
        }
      })
      .catch(error => {
        showApiError(error);
      });
  }


  function LoadDetailData(querystring) {
    ContributionsDetails(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json
          setDetail(json);
          //console.log(`loaddetaildata ${querystring}`)

        }
      })
      .catch(error => {
        showApiError(error);
      });
  }



  function handlePageChange(page, ps) {
    setCurrentPage( page)
  }
  
  function ShowPager(){
    if(data.length > 1) {
      //console.log(`number of pages: ${data.length}`)
      return (<Pagination 
         total={data.length } pageSize={1}
         current={currentPage}
         onChange={handlePageChange} />)
    }
    return null
  }

  function ShowContent() {
    if (currentPage > 0) {
      let item = data[currentPage - 1]
      return (
        <Row >
          <Col sm={24} md={18}>
            <div className='buttonsbar'>
              <CSVLink data={reportData} filename='contributions.csv' >
                <Button icon='file-excel'>Download CSV</Button> </CSVLink>
              <Button icon='file-pdf' onClick={() => setReadyPDF(true)} >Download PDF</Button>
              <CreateAndSavePDF data={data} reportData={reportData} ready={readyPDF} doFinish={FinishDownloadPDF}
                fromDate={search.fromDate} toDate={search.toDate} />
            </div>
            <ShowPager />
            <DetailReportContent displayName={item.displayName} data={detailData} />
          </Col>
        </Row>
      )
    } else return null
  }

  return (
    <div className="content">
      <h2>{props.title}</h2>
      <ContributionFilter
        fromDate={search.fromDate}
        toDate={search.toDate}
        doSearch={handleSearch}
        groupBy={-1}
      />
    <ShowContent />
    </div>
  );
}

export default DetailReportContainer;
